"use client";
import SimpleTextInput from "@/components/ui/Input/SimpleTextInput";
import EmailInvalidIndicator from "@/components/ui/Login/EmailInvalidIndicator";
import LoginWithGoogle from "@/components/ui/Login/LoginWithGoogle";
import AtSVG from "@/components/ui/SVGIcons/AtSVG";
import FingerprintSVG from "@/components/ui/SVGIcons/FingerprintSVG";
import UserShilloutteSVG from "@/components/ui/SVGIcons/UserShilloutteSVG";
import ConfirmSignUp from "@/components/ui/Signup/ConfirmSignUp";
import PasswordChecklist from "@/components/ui/Signup/PasswordChecklist";
import { IBackendManagerInterface } from "@/utils/BackendManager";
import { getLoginPath } from "@/utils/NavigationUtils";
import { toastError } from "@/utils/ToastsManager";
import { emailRegex, passwordRegex } from "@mltask/core/Utils/RegexHelper";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { useState } from "react";
import { useForm } from "react-hook-form";
import LocalAPIManager from "../../utils/LocalAPIManager";

var BackendManager: IBackendManagerInterface;
import("@/utils/BackendManager").then((lib) => {
  BackendManager = lib.default;
});

// import { AWSGlobalHandler } from "../awsGlobal";
export default function SignupPageUI() {
  const [showingConfirmation, setShowingConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const loadingStyle = "loading-md loading loading-dots text-secondary";
  const searchParams = useSearchParams();

  async function handleSignUpLogic() {
    setLoading(true);
    try {
      await LocalAPIManager.signupWithEmailAndPassword(email, password, name);
      setShowingConfirmation(true);
    } catch (error) {
      toastError();
    }
    setLoading(false);
  }

  function renderThirdPartySignupMethods() {
    return (
      <div className="flex">
        <LoginWithGoogle
          isLoading={loading}
          onClickCallback={async () => {
            setLoading(true);
            await BackendManager.signInWithGoogle(
              searchParams.get("mlapp") ?? undefined
            );
            setLoading(false);
          }}
        />
      </div>
    );
  }
  function renderManualSignupSection() {
    return (
      <form
        noValidate
        className="ng-untouched ng-pristine ng-valid space-y-8"
        onSubmit={handleSubmit((data) => {
          handleSignUpLogic();
        })}
      >
        <SimpleTextInput
          inputType="text"
          title="Name (Optional)"
          placeholder="Enter your name"
          value={name}
          onChange={(newValue) => {
            setName(newValue);
          }}
          SVGELement={<UserShilloutteSVG size={5} strokeWidth={2} />}
        />

        <SimpleTextInput
          registrar={register("email", {
            required: true,
            pattern: emailRegex,
            onChange: (e) => {
              setEmail(e.target.value);
            },
          })}
          errorSection={
            errors["email"] && <EmailInvalidIndicator email={email} />
          }
          inputType="email"
          title="Your Email"
          placeholder="Ex. john@smith.com"
          value={email}
          SVGELement={<AtSVG size={5} strokeWidth={2} />}
        />

        <SimpleTextInput
          registrar={register("password", {
            required: true,
            pattern: passwordRegex,
            onChange: (e) => {
              setPassword(e.target.value);
            },
          })}
          errorSection={
            errors.password && <PasswordChecklist password={password} />
          }
          inputType="password"
          title="Create a password"
          placeholder="********"
          value={password}
          SVGELement={<FingerprintSVG size={5} strokeWidth={2} />}
        />

        <div>
          <p className="my-2 text-center text-xs font-medium text-base-content">
            {`By clicking "Sign Up" you agree to our`}
            <Link
              href="/tos"
              className="text-primary hover:text-[color-mix(in_oklab,oklch(var(--p)),black_7%)]"
            >
              {" "}
              Terms of Service
            </Link>{" "}
            and{" "}
            <Link
              href="/privacypolicy"
              className="text-primary hover:text-[color-mix(in_oklab,oklch(var(--p)),black_7%)]"
            >
              Privacy Policy
            </Link>
            .
          </p>
          <button
            type="submit"
            className={`btn ${
              loading ? "btn-disabled" : ""
            } inline-flex w-full items-center justify-center  border border-transparent bg-gradient-to-r from-primary to-[color-mix(in_oklab,oklch(var(--p)),black_7%)] text-base font-semibold text-primary-content transition-all duration-200 hover:opacity-90 focus:opacity-90 focus:outline-none`}
          >
            {loading && <span className={`${loadingStyle}`}></span>}
            Sign up
          </button>
        </div>
      </form>
    );
  }
  function renderTitle() {
    let finalRedirectURL = `${getLoginPath()}`;
    if (searchParams.get("mlapp")) {
      finalRedirectURL += `?mlapp=${searchParams.get("mlapp")}`;
    }
    return (
      <div className="mb-8">
        <h2 className="text-center text-3xl font-bold leading-tight transition-all sm:text-4xl">
          Sign up
        </h2>
        <p className="mt-2 text-center text-lg ">
          Already have an account?{" "}
          <Link
            className="font-medium text-primary transition-all duration-200 hover:text-[color-mix(in_oklab,oklch(var(--p)),black_7%)] hover:underline "
            href={finalRedirectURL}
          >
            Login
          </Link>
        </p>
      </div>
    );
  }
  function renderOrSeparator() {
    return (
      <div className="divider my-8 h-px  p-0 font-bold ">
        <span className="px-2 ">Or</span>
      </div>
    );
  }
  function signupSection() {
    return (
      <div className="w-full">
        <div className="flex flex-col items-center justify-center ">
          <div className="w-full rounded-lg bg-base-100 p-8 text-base-content shadow-md shadow-neutral ">
            {renderTitle()}
            {renderThirdPartySignupMethods()}
            {renderOrSeparator()}
            {renderManualSignupSection()}
          </div>
        </div>
      </div>
    );
  }
  function renderSignupSection() {
    if (showingConfirmation) return;
    return signupSection();
  }
  function renderShowingConfirmationSection() {
    if (showingConfirmation == false) return;
    return (
      <ConfirmSignUp
        email={email}
        password={password}
        isVerifyingWithLink={true}
      />
    );
  }
  return (
    <section className="mx-auto my-auto flex max-w-xl p-4">
      {renderSignupSection()}
      {renderShowingConfirmationSection()}
    </section>
  );
}
